export default "__VITE_ASSET__5a1978c6__"